import { Base64 } from 'js-base64';
import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const base64Validator = ({ requiredError, minLength, maxLength, length, invalidFormatError, }) => {
    let validator = z.string({
        error: createErrorHandler(requiredError),
    });
    if (minLength) {
        validator = validator.min(minLength.min, minLength.error);
    }
    if (maxLength) {
        validator = validator.max(maxLength.max, maxLength.error);
    }
    if (length) {
        validator = validator.length(length.len, length.error);
    }
    return validator.refine(Base64.isValid, invalidFormatError);
};
